export const EDIT_INVESTMENT_VALUE_DETAILS = 'EDIT_INVESTMENT_VALUE_DETAILS';
export const EDIT_INVESTMENT_ERROR_DETAILS = 'EDIT_INVESTMENT_ERROR_DETAILS';
export const REMOVE_INVESTMENT_DATA = 'REMOVE_INVESTMENT_DATA';
export const INITIAL_DATA = 'INITIAL_DATA';

export interface InvestmentFormType {
    value: {
        [key: string]: {
            schemeId?: string,
            lumpsum?: {
                lumpAmount: string,
                lumpsumFolio: string
            },
            sip?: {
                sipamount?: string,
                periods?: string,
                installments?: string,
                sipDate?: string,
                mandate?: string,
                sipFolio?: string,
            }
        }
    },
    error: {
        [key: string]: {
            schemeId?: string,
            lumpsum?: {
                lumpAmount?: string,
                lumpsumFolio?: string
            },
            sip?: {
                sipamount?: string,
                periods?: string,
                installments?: string,
                sipDate?: string,
                mandate?: string,
                sipFolio?: string,
            }
        }
    }
}

export interface GetSchemeDataResponseType {
    totalLength: number
    currentPageFunds: SwitchSchemeObj[]
}

export type SchemeAllowType = 'Y' | 'N';

export interface SwitchSchemeObj {
    scheme: string
    schemeName: string
    company: string
    companyName: string
    category: string
    categoryName: string
    subCategory: string
    subCategoryName: string
    isinCode: string
    interfaceCode: string
    riskType: string
    navDate: any
    aum: number
    currentNav: number
    expenseRatio: number
    purchaseAllowed: string
    purTransMode: any
    addnlPurAmount: number
    redAllowed: SchemeAllowType
    redTransMode: string
    divReinvestAllowed: any
    sipAllowed: SchemeAllowType
    stpAllowed: SchemeAllowType
    swpAllowed: SchemeAllowType
    switchAllowed: SchemeAllowType
    settlementType: any
    exitLoadApplicable: string
    exitLoad: number
    exitLoadNote: any
    lockingPrdApplicable: string
    lockingPeriod: number
    month1Return: number
    month3Return: number
    month6Return: number
    year1Return: number
    year3Return: number
    year5Return: number
    sinceInception: number
}